import { CardBrand, CartPaymentCardType } from '@fhs-legacy/frontend/src/generated/graphql-gateway';

// Detect card brand from card number using number patterns
export function detectCardBrand(cardNumber: string): CartPaymentCardType {
  const cleanNumber = cardNumber.replace(/\s/g, '');

  if (cleanNumber.startsWith('4')) {
    return CartPaymentCardType.VISA;
  }
  if (/^5[1-5]/.test(cleanNumber) || /^2[2-7]/.test(cleanNumber)) {
    return CartPaymentCardType.MASTERCARD;
  }
  if (/^3[47]/.test(cleanNumber)) {
    return CartPaymentCardType.AMEX;
  }
  if (/^6(?:011|5)/.test(cleanNumber)) {
    return CartPaymentCardType.DISCOVER;
  }

  return CartPaymentCardType.CREDIT;
}

// Map saved card's CardBrand to CartPaymentCardType duplicate enums on backend
export function mapCardBrandToCartPaymentCardType(cardBrand: CardBrand): CartPaymentCardType {
  const brandString = cardBrand.toString().toUpperCase();
  // CardBrand values like 'VISA', 'MASTERCARD', 'AMEX', etc match CartPaymentCardType enum
  return (
    CartPaymentCardType[brandString as keyof typeof CartPaymentCardType] ||
    CartPaymentCardType.CREDIT
  );
}
